import React, { useRef, useState } from 'react';
import Collapse from 'react-css-collapse';

import { ReactComponent as Chevron } from '../../images/icons/chevron-down.svg';
import * as styles from './StickyNav.module.scss';

const StickyNav = ({ title = 'Table of Contents', items = [], visibleSection = null, headerAdjust = false }) => {
  const [openState, setOpenState] = useState(false);
  const listRef = useRef();

  const scrollTo = (id) => {
    if (typeof window === 'undefined' || !document) return;
    const el = document.getElementById(id);
    if (el) {
      setOpenState(false);
      const y = el.getBoundingClientRect().top + window.scrollY - 55;
      window.scrollTo({
        top: y,
        behavior: 'smooth',
      });
      window.history.pushState(null, null, `#${id}`);
    }
  };

  const toggle = () => {
    setOpenState(!openState);
  };

  let tocTitle = title;
  if (visibleSection) {
    const item = items.find((s) => s.id === visibleSection);
    if (item) {
      tocTitle = item.title;
    }
  }

  let heading = openState ? title : tocTitle || title;

  return (
    <nav data-analytics-component="sticky-nav" className={[styles.wrap, styles.stick].join(' ')}>
      <button
        className={[styles.headingButton, openState ? styles.headingButtonOpen : styles.headingButtonClosed].join(' ')}
        onClick={toggle}
      >
        {heading}
        <Chevron />
      </button>
      <Collapse isOpen={openState} className={styles.collapser}>
        <ul ref={listRef}>
          {items.map((item, i) => {
            if (!item) {
              return null;
            }
            return (
              <li key={i} className={[visibleSection === item.id ? styles.current : ''].join(' ')}>
                <button data-analytics-id={item.title} onClick={() => scrollTo(item.id)}>
                  {item.title}
                </button>
              </li>
            );
          })}
        </ul>
      </Collapse>
    </nav>
  );
};

export default StickyNav;
